import script from "./dog-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./dog-modal.vue?vue&type=script&setup=true&lang=js"

import "./dog-modal.vue?vue&type=style&index=0&id=6f9473b1&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9473b1"]])

export default __exports__